import type { ComponentProps } from 'react';

import { HomeNovaPage } from '@/components/home-nova/page';
import { HOME_PAGE_DEFAULT_KEY, HOME_PAGES, isHomePageKey } from '@/constants/home-pages';
import type { HomeVariantProps } from '@/interface/home-pages';

// A Home que recebe a variante: a Home nova (src/components/home-nova/page).
const Home = HomeNovaPage;

type HomeVariantSwitcherProps = { variantKey: string } & Omit<ComponentProps<typeof Home>, keyof HomeVariantProps>;

// Renderizador puro, no modelo do TrialLayoutSwitcher: quem decide a variante é o servidor (na `/`,
// a api pelo pickHome de src/pages/index.tsx; no preview, a URL). Ele só
// traduz a chave em cta/visual pelo registry — chave desconhecida vira home-v1, nunca uma Home sem variante.
export const HomeVariantSwitcher = ({ variantKey, ...homeProps }: HomeVariantSwitcherProps) => {
  const variant = HOME_PAGES[isHomePageKey(variantKey) ? variantKey : HOME_PAGE_DEFAULT_KEY];

  return <Home {...homeProps} variantKey={variant.key} cta={variant.cta} visual={variant.visual} />;
};
